import { render } from "./FeedbackButton.vue?vue&type=template&id=f3f0b778"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__